<template>
    <div>
        <h2 class="text-lg-h5 font-weight-bold">Not-Aus
            <span
                v-if="selectedSite">: {{ selectedSite.Name }}</span>
        </h2>
        <div class="d-flex flex-column">
            <Toggle v-model="onlyStopped" label="Nur deaktivierte Seiten anzeigen"></Toggle>
            <PublisherSelect store="emergency"></PublisherSelect>
            <div style="width: 500px">
                <SiteSelect v-model="selectedSite" :onlyStoppedSites="onlyStopped" store="emergency"
                            @beforeChange="beforeSiteChange"
                            :beforeChangeEvent="true">
                    <TooltipIcon
                        v-if="!$vuetify.breakpoint.smAndDown"
                        :custom-style="{marginLeft:'10px'}"
                        :color="ada.darkGrey" :fab="true" :xsmall="true"
                        :tooltip="'Seitenliste '+ (showSitesList ? 'ausblenden' : 'einblenden')"
                        @click="showSitesList = !showSitesList">
                        mdi-format-list-bulleted
                    </TooltipIcon>
                </SiteSelect>
            </div>
        </div>
        <v-row no-gutters class="mt-4">
            <v-col :cols="showSitesList ? 3 : 0" v-if="!$vuetify.breakpoint.smAndDown">
                <SitesList v-model="selectedSite" :show="showSitesList" store="emergency" class="mr-4"
                           :style="{maxHeight: detailsRowHeight+'px', height:detailsRowHeight+'px'}"
                           :key="detailsRowHeight"></SitesList>
            </v-col>
            <v-col :cols="showSitesList ? 9 : 12">
                <v-tabs v-model="activeTab" :color="ada.blue" show-arrows ref="tabHeader">
                    <v-tabs-slider :color="ada.blue"></v-tabs-slider>
                    <v-tab flat v-for="tab in tabs" :key="tab.name">
                        <span>{{ tab.name }}</span>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="activeTab" ref="tabContent">
                    <v-tab-item
                        v-for="tab in tabs"
                        :key="tab.name+'_i'"
                    >
                        <v-card flat>
                            <v-card-text style="min-height: 400px;">
                                <transition name="fade" mode="out-in">
                                    <component
                                        v-if="!siteLoading"
                                        :is="tab.component"
                                        :loading="loading"
                                        @change="handleChange"
                                        @submit="handleValidation"
                                        @snackbar="activateSnackbar"
                                        @activeComponent="updateActiveComponent"/>
                                </transition>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <SaveChangesDialog v-model="showSaveChangesDialog" @discard="triggerChildsInit"
                           @save="submit"></SaveChangesDialog>
    </div>
</template>

<script>
import SiteSelect from "../components/SiteSelect";
import PublisherSelect from "../components/PublisherSelect";
import ada from "../../scss/ada_colors.scss";
import Emergency_General from "./Tabs/Emergency_General";
import Emergency_Zones from "./Tabs/Emergency_Zones";
import Emergency_Configuration from "./Tabs/Emergency_Configuration";
import SaveChangesDialog from "../components/SaveChangesDialog";
import Toggle from "../../components/buttons/Toggle";
import TooltipIcon from "../../components/TooltipIcon";
import SitesList from "../components/SitesList";

export default {
    name: "EmergencyStop",
    components: {
        SitesList,
        TooltipIcon,
        Toggle,
        SaveChangesDialog,
        Emergency_Configuration, Emergency_Zones, Emergency_General, PublisherSelect, SiteSelect
    },
    data: () => {
        return {
            prevSelectedSite: null,
            selectedSite: null,
            activeTab: null,
            ignoreUpdate: false,
            showSaveChangesDialog: false,
            showSitesList: true,
            onlyStopped: 0,
            tabs: [
                {name: 'Not-Aus: Allgemein', component: 'Emergency_General'},
                {name: 'Not-Aus: Zone', component: 'Emergency_Zones'},
                {name: 'Konfiguration', component: 'Emergency_Configuration'},
            ],
            tab_component: null, //previous Component -> needed after switching tabs
            loading: false,
            activeComponent: null, //current Component
            beforeRouteLeave: false,
            beforeSiteLeave: false,
            key: 0,
            detailsRowHeight: 400,
            minHeight: 450,
            ada,
        }
    },
    beforeRouteLeave(to, from, next) {
        this.next = next;
        this.beforeRouteLeave = true;
        this.handleChange();
    },
    mounted() {
        if (this.storeSelectedSite) {
            this.ignoreUpdate = true;
            this.selectedSite = this.storeSelectedSite;
        }
        this.observeHeight()
    },
    computed: {
        vuexState() {
            return this.$store.state.emergency;
        },
        storeSelectedSite() {
            return this.vuexState.selectedSite;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        selectedPublisher() {
            return this.vuexState.selectedPublisher;
        },
        siteLoading() {
            return this.vuexState.loading;
        },
        detailsContentMinHeight() {
            return this.$store.state.display.detailsContentMinHeight;
        },
        beforeLeave() {
            return (this.beforeRouteLeave || this.beforeSiteLeave)
        },
        role() {
            return this.$store.state.users.role;
        }
    },
    methods: {
        async updateSelectedSite() {
            this.$store.commit('emergency/updateSelectedSite', this.selectedSite);
            if (this.selectedSite) this.fetchTypesForEmergency();
        },
        fetchTypesForEmergency() {
            this.$store.dispatch('emergency/fetchTypesForEmergency')
        },
        activateSnackbar(msg, error = false) {
            if (error && this.showSaveChangesDialog) this.showSaveChangesDialog = false;
            if (msg === 'Erfolgreich gespeichert.') {
                this.showSaveChangesDialog = false;
            }
            this.$root.$emit('snackbar', msg, error ? 'error' : 'success');
        },
        appendDisabledSitesOrZonesToBody(body) {
            let config = {
                typeIsDisabled: this.vuexState.disabledSitetypes,
                zoneIsDisabled: this.vuexState.disabledZones
            }
            Object.keys(config).forEach((key) => {
                if (config[key].length !== 0) {
                    config[key].forEach((id) => {
                        body[key] = body[key] || {};
                        body[key][id] = 1;
                    })
                }
            })
            return body;
        },
        getBody() {
            let json = {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                siteIsDisabled: this.vuexState.siteIsDisabled,
                ExternalIsEnabled: this.vuexState.externalIsEnabled,
            };
            return this.appendDisabledSitesOrZonesToBody(json);
        },
        async submit() {
            this.loading = true;
            try {
                let tmpComponent = this.beforeLeave ? this.activeComponent : this.tab_component;
                let json = typeof tmpComponent.getBody !== "undefined" ? tmpComponent.getBody() : this.getBody();
                let dispatchAction = typeof tmpComponent.getBody !== "undefined" ? 'saveEmergencyConfig' : 'saveEmergency'
                let data = await this.$store.dispatch('emergency/' + dispatchAction, json);
                if (data.Status) {
                    this.activateSnackbar("Erfolgreich gespeichert.");
                } else {
                    this.tab = this.tabs.findIndex(x => x.component === this.vuexState.previousTab);
                    this.activateSnackbar("Speichern fehlgeschlagen.", true);
                }
                this.triggerNext();
                this.showSaveChangesDialog = false;
                this.loading = false;
            } catch (e) {
                console.error(e);
                this.loading = false;
            }
        },
        handleValidation(component) {
            this.tab_component = component;
            if (component.dataChanged()) {
                this.submit();
                if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
            } else {
                this.activateSnackbar('Es wurden keine Änderungen festgestellt.');
            }
            this.triggerNext();
        },
        handleChange(component) {
            this.tab_component = component;
            let tmp_component = this.beforeLeave ? this.activeComponent : this.tab_component;
            if (this.$store.state.readOnly === 0 && this.selectedSite && tmp_component.dataChanged() &&
                (this.activeTab !== tmp_component.$options._componentTag || this.beforeLeave)
            ) {
                this.showSaveChangesDialog = true;
            } else {
                this.triggerNext();
            }
        },
        updateActiveTab(name) {
            this.$store.commit('emergency/updateActiveTab', name);
        },
        triggerChildsInit() {
            let tmp_component = this.beforeLeave ? this.activeComponent : this.tab_component;
            if (typeof tmp_component.init !== "undefined") {
                tmp_component.init();
            }
            if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
            this.triggerNext();
        },
        updateActiveComponent(component) {
            this.activeComponent = component;
        },
        triggerNext() {
            if (this.beforeRouteLeave) {
                this.beforeRouteLeave = false;
                if (this.next) this.next();
                this.next = null;
            }
            if (this.beforeSiteLeave) {
                this.beforeSiteLeave = false;
                this.selectedSite = this.siteToBeChangedTo;
            }
        },
        beforeSiteChange($event) {
            this.prevSelectedSite = this.selectedSite;
            this.siteToBeChangedTo = $event;
            this.beforeSiteLeave = true;
            this.handleChange();
        },
        observeHeight() {
            const resizeObserver = new ResizeObserver(() => {
                if (this.$refs.tabContent && this.$refs.tabHeader) {
                    let calcHeight = this.$refs.tabContent.$el.clientHeight + this.$refs.tabHeader.$el.clientHeight;
                    this.detailsRowHeight = calcHeight > this.minHeight ? calcHeight : this.minHeight;
                }
            });
            resizeObserver.observe(this.$refs.tabContent.$el);
        },
    },
    watch: {
        tab(newValue) {
            this.updateActiveTab(this.tabs[newValue].component);
        },
        selectedSite() {
            if (this.ignoreUpdate) {
                this.ignoreUpdate = false;
            } else {
                this.updateSelectedSite();
            }
        },
        selectedPublisher() {
            this.selectedSite = null;
            this.updateSelectedSite();
        },
    }
}
</script>

<style scoped>

</style>